// removed by extract-text-webpack-plugin
module.exports = {"header":"header--2IyJE"};